import getEndpoint from '@/helpers/getEndpoint'
import API from '@/services/API'
import { CartItem } from '@/ts/Cart'

export async function sendCartProductIds(cart: CartItem[]) {
  const endpoint = getEndpoint('CHECKOUT_SIMILAR_PRODUCTS')
  const productIds = cart.map((item) => item.id)

  const body = { product_ids: productIds }

  const response = await API.post<{ ids: number[] }>(endpoint, { body })

  if (response.status === 'success') {
    return response
  } else {
    throw new Error()
  }
}
